module.exports = __webpack_public_path__ + "static/media/icon-email.ec985e37.svg";